import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import BranchForm from "./BranchForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { branchValidationForm } from "../../utils/validationSchemas";
import Card from "../Reusable/Card";
//@ts-ignore
import BankDetails from "./BankDetails";
import SwitchButton from "../Reusable/SwitchButton";

const EditBranch = (props: any) => {
  const {
    handleEdit,
    isLoading,
    branchData,
    handleIsEnableSMS,
    handleIsEnableEmail,
    handleIsActive,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    watch,
    control,
  } = useForm<any>({
    resolver: yupResolver(branchValidationForm),
    defaultValues: async () => {
      return {
        ...branchData,
        service_branch: branchData?.service_branch
          ? branchData?.service_branch?.map((item: any) => ({
              label: item?.name,
              value: item?.id,
            }))
          : [],
        charge_type: {
          name: branchData?.charge_type,
          id: branchData?.charge_type,
        },
        charge: branchData?.charge,
        transit_charge: branchData?.transit_charge,
        default_rate_template: branchData?.default_rate_template,
        covered_city: branchData?.covered_city
          ? branchData?.covered_city?.map((item: any) => ({
              label: item?.name,
              value: item?.id,
            }))
          : [],
      };
    },
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <BranchForm
          errors={errors}
          clearErrors={clearErrors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          branchData={branchData}
          control={control}
          isCreate={false}
        />
      </FormLayout>
    </>
  );
};

export default EditBranch;
